import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-notification__content" }
const _hoisted_2 = { class: "app-notification__title" }
const _hoisted_3 = { class: "app-notification__message" }
const _hoisted_4 = { class: "app-notification__action" }
const _hoisted_5 = {
  key: 0,
  class: "app-notification__close-btn"
}

import {
  NotificationAction,
  NotificationVariant,
} from '@/services/notification.app'
import AppButton from '@/app/components/button/AppButton.vue'

/**
 * This is component is bare component for displaying notifications.
 * It defines specific styles for the different variants.
 *
 * @param variant (NotificationVariant) - Visual style variant:
 * 'unique' | 'success' | 'error' | 'warning' | 'info'. Default: 'unique'
 * @param actions (NotificationAction[]) - Array of action buttons with
 * `{ label: string, onClick: () => void }`. Default: []
 *   Note - if no actions are passed, the close button is displayed
 *        you can use the action slot to override all default action behavior
 * @event close - Emitted when the close button is clicked
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotification',
  props: {
    variant: { default: 'unique' },
    actions: { default: () => ([]) }
  },
  emits: ['close'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['app-notification', `app-notification--${__props.variant}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createElementVNode("p", _hoisted_3, [
        _renderSlot(_ctx.$slots, "message")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "action", {}, () => [
        (__props.actions.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "app-notification__close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "app-notification__close-icon iconfont iclose" }, null, -1)
              ]))])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action, index) => {
          return (_openBlock(), _createBlock(AppButton, {
            key: index,
            dense: true,
            class: "app-notification__action--button",
            onClick: ($event: any) => (action.onClick())
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(action.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})